import { Activity, Bell, MapPin, MessageCircle, PieChart, Settings, Truck } from 'react-feather';
import { Role } from './roles';
import { FlaskConical, Inbox, Route, TriangleAlert, Warehouse } from 'lucide-react';
import { isDevEnvironment } from 'core/utilities/environment';

const BaseSidebarOptions = [
  {
    icon: <PieChart />,
    label: 'Dashboard',
    route: 'dashboard',
    // Logistics and transport are here for the Delivery Requests tab, not for
    // the delivery rounds — the tabs themselves are roled in
    // core/constants/dashboard-tab.ts.
    roles: [
      Role.SUPER_ADMIN,
      Role.PHARMACY_ADMIN,
      Role.PHARMACY_DISPENSER,
      Role.LOGISTICS_ADMIN,
      Role.TRANSPORT_ADMIN,
    ],
  },
  {
    icon: <Inbox />,
    label: 'Delivery Requests',
    route: 'delivery-requests',
    roles: [Role.SUPER_ADMIN, Role.LOGISTICS_ADMIN, Role.TRANSPORT_ADMIN],
  },
  {
    icon: <Route />,
    label: 'Transport',
    route: 'transport',
    roles: [Role.SUPER_ADMIN, Role.TRANSPORT_ADMIN],
  },
  {
    icon: <Truck />,
    label: 'Deliveries',
    route: 'deliveries',
    roles: [Role.SUPER_ADMIN, Role.PHARMACY_ADMIN, Role.PHARMACY_DISPENSER],
  },
  {
    icon: <TriangleAlert />,
    label: 'Unallocated',
    route: 'unallocated',
    roles: [Role.SUPER_ADMIN, Role.PHARMACY_ADMIN, Role.PHARMACY_DISPENSER],
  },
  {
    icon: <MapPin />,
    label: 'Routes',
    route: 'routes',
    roles: [Role.SUPER_ADMIN, Role.PHARMACY_ADMIN, Role.PHARMACY_DISPENSER],
  },
  {
    icon: <MessageCircle />,
    label: 'Driver Messages',
    route: 'driver-messages',
    roles: [Role.SUPER_ADMIN, Role.PHARMACY_ADMIN, Role.PHARMACY_DISPENSER],
  },
  {
    icon: <Truck />,
    label: 'Vehicle Checks',
    route: 'vehicle-checks',
    roles: [Role.SUPER_ADMIN, Role.LOGISTICS_ADMIN],
  },
  {
    icon: <Bell />,
    label: 'Alerts',
    route: 'alerts',
    roles: [Role.SUPER_ADMIN, Role.LOGISTICS_ADMIN],
  },
  {
    icon: <Activity />,
    label: 'Run Activity',
    route: 'run-activity',
    roles: [Role.SUPER_ADMIN, Role.LOGISTICS_ADMIN],
  },
  {
    icon: <Warehouse />,
    label: 'RDC',
    route: 'rdc',
    roles: [Role.SUPER_ADMIN, Role.LOGISTICS_ADMIN],
  },
  {
    icon: <Settings />,
    label: 'Settings',
    route: 'settings',
    roles: [Role.SUPER_ADMIN, Role.PHARMACY_ADMIN, Role.LOGISTICS_ADMIN],
  },
];

/**
 * Dev tooling is appended only outside production, so the entry never reaches
 * a client-facing build.
 */
export const SidebarOptions = isDevEnvironment()
  ? [
      ...BaseSidebarOptions,
      {
        icon: <FlaskConical />,
        label: 'Dev Tools',
        route: 'dev-tools',
        roles: [Role.SUPER_ADMIN],
      },
    ]
  : BaseSidebarOptions;
